
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf/[slug]",
      function () {
        return require("private-next-pages/surf/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf/[slug]"])
      });
    }
  